module.exports = __webpack_public_path__ + "img/TopMain_Mobile.d6a95da4.jpg";